import { css } from 'styled-components';
import token from 'styled-token';
import { StyledTag } from '../../components/Tag/Tag.styles';
export var ProgressStepperStepLabelMixin = function ProgressStepperStepLabelMixin(props) {
  var active = props.active,
    appearance = props.appearance,
    alignLabel = props.alignLabel;
  return token({
    interactiveStepSize: 'ProgressStepper.interactiveStepSize',
    labelOffset: 'ProgressStepper.labelOffset',
    nonInteractiveStepSize: 'ProgressStepper.nonInteractiveStepSize',
    tagMarginTop: 'ProgressStepper.tagMarginTop'
  }, function (_ref) {
    var interactiveStepSize = _ref.interactiveStepSize,
      labelOffset = _ref.labelOffset,
      nonInteractiveStepSize = _ref.nonInteractiveStepSize,
      tagMarginTop = _ref.tagMarginTop;
    return css(["margin-top:", "px;text-align:", ";word-break:break-all;", "{margin-top:", "px;}"], appearance || active ? labelOffset : labelOffset + (interactiveStepSize - nonInteractiveStepSize) / 2, alignLabel, StyledTag, tagMarginTop);
  })(props);
};